import {Button} from '@primer/react-brand/esm'
import {clsx} from 'clsx'
import type {MouseEventHandler} from 'react'

import {
  renderNativeShareButton,
  renderNativeShareFeedback,
  useNativeShareAction,
  type CopyToClipboard,
  type NativeShare,
  type NativeShareCopy,
} from '@github-ui/swp-core/components/NativeShareAction'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import Styles from './MobileCta.module.css'

export type MobileCtaLocation = 'hero' | 'highlight' | 'cta_banner'
export type {CopyToClipboard, NativeShare}
export type MobileNativeShareCopy = NativeShareCopy

export type MobileCtaConfig =
  | {
      kind: 'emailHandoff'
      label: string
      onClick: MouseEventHandler<HTMLButtonElement>
    }
  | {
      kind: 'nativeShare'
      clipboardWrite?: CopyToClipboard | null
      copy: MobileNativeShareCopy
      share?: NativeShare | null
    }

type MobileCtaProps = {
  block?: boolean
  className?: string
  config: MobileCtaConfig
  location: MobileCtaLocation
}

export function MobileCta({block, className, config, location}: MobileCtaProps) {
  const nativeShareController = useNativeShareAction(config.kind === 'nativeShare' ? config : {})

  if (config.kind === 'emailHandoff') {
    return (
      <Button
        aria-haspopup="dialog"
        block={block}
        className={className}
        type="button"
        variant="primary"
        {...getAnalyticsEvent({
          action: config.label,
          tag: 'button',
          context: 'mobile_handoff',
          location,
        })}
        onClick={config.onClick}
      >
        {config.label}
      </Button>
    )
  }

  return (
    <div className={clsx(Styles.MobileCta, className)}>
      {renderNativeShareButton({
        analytics: {
          context: 'mobile_native_share',
          fallbackContext: 'mobile_native_share_fallback',
          location,
        },
        block,
        controller: nativeShareController,
      })}
      {renderNativeShareFeedback(nativeShareController, Styles.MobileCta__message)}
    </div>
  )
}
